// counter.ts
import * as companies from '../actions/companies.actions';
import { Company } from '../models/company';

export interface State {
  searchTerm: string;
  isSearching: boolean;
  searchError: boolean
  isFetching: boolean;
  tabName: string;
  pageSize: number;
  companies: any;
  results: {
    [tabName: string]: {
      searchTerm: string;
      isSearching: boolean;
      pageIndex: number;
      error: boolean;
      data: Company[]
    }
  }
  meta: any;
}

export const initialState: any = {
  searchTerm: '',
  isSearching: false,
  searchResults: [],
  searchError: false,
  companies: [],
  meta: {}
};

export function reducer(state: State = initialState, action: companies.Actions): State {

  switch (action.type) {

    case companies.FETCH:
    state.isFetching = true;
    return state;

    case companies.FETCH_SUCCESS:
      state.isFetching = false;
      return Object.assign({}
        , state
        , { companies: action.payload.companies, meta: action.payload.meta });

    case companies.RESET:
      return Object.assign({}, initialState);

    case companies.FUZZY_FETCH:
      return Object.assign({}
        , state
        , { results: { fuzzySearch: { isSearching: true, searchTerm: action.payload, data: null, error: false } } });

    case companies.FUZZY_FETCH_SUCCESS:
      return Object.assign({}
        , state
        , { results: { fuzzySearch: { isSearching: false, data: action.payload, error: false } } });

    case companies.FUZZY_FETCH_FAILURE:
      return Object.assign({}
        , state
        , { results: { fuzzySearch: { isSearching: false, searchTerm: action.payload, data: null, error: true } } });

    default:
      return state;
  }
}

export const getCompanies = (state: State) => state.companies;
export const getCompanyMeta = (state: State) => state.meta;
export const getFuzzyResults = (state: State) => state.results.fuzzySearch;



// WEBPACK FOOTER //
// ./src/reducers/companies.reducer.ts